import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';


import {
  ListagemUsuarios,
  DetalheUsuario,
  ListagemPermissao,
  PlanoDeContas,
  ListagemDeClientes,
  DetalheDeClientes,
  ListagemDeFabricas,
  ListagemDeProdutos,
  ListagemDeOperacoes,
  ListagemDeCreditos,
  DetalheDeProdutos,
  
}from '../pages/cadastros'; 

import {
   ListagemDePedidoDireto,
   DetalhePedidoDireto,
   ListagemDePedidoNota,
   DetalhePedidoNota,
   ListagemDeTalaoPedido,
   DetalheTalaoPedido,
   PrecoCliente,
   DashboardVendas
 } from '../pages/vendas';

 import {
  RelatoriosVendas,
  RelatoriosVendasfabrica,
  RelatoriosEstoque,
  Etiquetas,
  
} from '../pages/relatorios';

import { useDrawerContext } from '../shared/contexts';
import RelatorioVendasfabrica from '../pages/relatorios/vendasfabrica/relatoriosvendafabrica';
import { EtiquetasGrand } from '../pages/relatorios/estoque/EtiquetasGrand';

export const AppRoutes = () => {
  const {toggleDrawerOpen, setDrawerOptions, setDrawerItemOptions} = useDrawerContext();

  useEffect(()=>{
    setDrawerOptions([
      {
       label: 'Cadastros',
       icon: 'home',
       path: '/cadastros',
      },
      {
        label: 'Vendas',
        icon: 'attach_money',
        path: '/vendas',
       },
       {
        label: 'Relatórios',
        icon: 'library_books',
        path: '/relatorios',
       }
    ]);
    
    setDrawerItemOptions([
      {
       label: 'Clientes',
       icon: 'people',
       path: '/clientes',
       parent: '/cadastros'
      },
      {
        label: 'Operaçoes',
        icon: 'people',
        path: '/operacoes',
        parent: '/cadastros'
       },
      {
        label: 'Usuarios',
        icon: 'people',
        path: '/usuarios',
        parent: '/cadastros'
       },
      {
        label: 'Fabricas',
        icon: 'factory',
        path: 'fabricas',
        parent: '/cadastros'
       },
      {
       label: 'Produtos',
       icon: 'inventory2',
       path: '/produtos',
       parent: '/cadastros'
      },
      {
        label: 'Créditos',
        icon: 'inventory2',
        path: '/creditos',
        parent: '/cadastros'
       },
      //  {
      //   label: 'Dashboard',
      //   icon: 'inventory2',
      //   path: '/dashvenda',
      //   parent: '/vendas'
      //  },
      {
        label: 'Pedido Direto',
        icon: 'inventory2',
        path: '/pedidodireto',
        parent: '/vendas'
       },
       {
        label: 'Pedido Nota',
        icon: 'inventory2',
        path: '/pedidonota',
        parent: '/vendas'
       },
       {
        label: 'Talão Pedido',
        icon: 'inventory2',
        path: '/talaopedido',
        parent: '/vendas'
       },
       
       {
        label: 'Vendas',
        icon: 'library_books',
        path: '/relatoriosvendas',
        parent: '/relatorios'
       },
       {
        label: 'Vendas Fabrica',
        icon: 'library_books',
        path: '/relatoriosvendasfabrica',
        parent: '/relatorios'
       },
       {
        label: 'Estoque',
        icon: 'library_books',
        path: '/relatoriosestoque',
        parent: '/relatorios'
       },
       {
        label: 'Etiquetas',
        icon: 'library_books',
        path: '/etiquetas',
        parent: '/relatorios'
       },
       {
        label: 'Etiquetas Grand',
        icon: 'library_books',
        path: '/etiquetasgrand',
        parent: '/relatorios'
       }
    ]);
  },[]);

  return (
    <Routes>
      <Route path="/usuarios" element={<ListagemUsuarios />} />
      <Route path="/usuarios/:id" element={<DetalheUsuario />} />
      <Route path="/usuarios/permissoes/:id/:nome" element={<ListagemPermissao />} />
      <Route path="/planodecontas" element={<PlanoDeContas/>} />
      <Route path='/clientes' element={<ListagemDeClientes/>}/>
      <Route path='/clientes/:id' element={<DetalheDeClientes/>}/>
      <Route path='/fabricas' element={<ListagemDeFabricas/>}/>
      <Route path='/produtos' element={<ListagemDeProdutos/>}/>
      <Route path='/produtos/:id' element={<DetalheDeProdutos/>}/>
      <Route path='/operacoes' element={<ListagemDeOperacoes/>}/>
      <Route path='/creditos' element={<ListagemDeCreditos/>}/>
      <Route path='/pedidodireto' element={<ListagemDePedidoDireto/>}/>

      <Route path='/dashvenda' element={<DashboardVendas/>}/>
      <Route path='/pedidodireto/:id' element={<DetalhePedidoDireto/>}/>
      <Route path='/talaopedido' element={<ListagemDeTalaoPedido/>}/>
      <Route path='/talaopedido/:id' element={<DetalheTalaoPedido/>}/>
      <Route path='/pedidonota' element={<ListagemDePedidoNota/>}/>
      <Route path='/precocliente' element={<PrecoCliente/>}/>
      <Route path='/pedidonota/:id' element={<DetalhePedidoNota/>}/>
      <Route path='/relatoriosvendas' element={<RelatoriosVendas/>}/>
      <Route path='/relatoriosvendasfabrica' element={<RelatoriosVendasfabrica/>}/>
      <Route path='/relatoriosestoque' element={<RelatoriosEstoque/>}/>
      <Route path='/etiquetas' element={<Etiquetas/>}/>
      <Route path='/etiquetasgrand' element={<EtiquetasGrand/>}/>
     
      <Route path="*" element={<Navigate to="/pedidodireto" />} />
    </Routes>
  );
};